import { SIZE_50, SIZE_33, SIZE_FULL } from '@/lib/gridElements/size';

//kpis
import { totalEngagementConfig } from '@/lib/analytics/kpis/linkedin/totalEngagement';
import { avgEngagementRatePostConfig } from '@/lib/analytics/kpis/linkedin/avgEngagementRatePost';
import { avgEngagementOnImpressionConfig } from '@/lib/analytics/kpis/linkedin/avgEngagementOnImpression';
import { totalReactionsConfig } from '@/lib/analytics/kpis/linkedin/totalReactions';
import { avgReactionsConfig } from '@/lib/analytics/kpis/linkedin/avgReactions';
import { totalCommentsReceivedConfig } from '@/lib/analytics/kpis/linkedin/totalCommentsReceived';
import { avgCommentsConfig } from '@/lib/analytics/kpis/linkedin/avgComments';
import { totalSharesConfig } from '@/lib/analytics/kpis/linkedin/totalShares';
import { avgSharesConfig } from '@/lib/analytics/kpis/linkedin/avgShares';
import { totalClicksConfig } from '@/lib/analytics/kpis/linkedin/totalClicks';
import { avgClicksPerPostConfig } from '@/lib/analytics/kpis/linkedin/avgClicksPerPost';
import { totalViewsConfig } from '@/lib/analytics/kpis/linkedin/totalViews';
import { avgVideoViewsConfig } from '@/lib/analytics/kpis/linkedin/avgVideoViews';

//charts
import { reactionsHistoryConfig } from '@/lib/analytics/charts/linkedin/reactionsHistory';
import { commentsHistoryConfig } from '@/lib/analytics/charts/linkedin/commentsHistory';
import { bestTimeToPostConfig } from '@/lib/analytics/charts/linkedin/bestTimeToPostConfig';
import { avgEngagementsPostTypeConfig } from '@/lib/analytics/charts/linkedin/avgEngagementPostType';
import { avgEngagementRateHistoryConfig } from '@/lib/analytics/charts/linkedin/averageEngagementRateHistory';
import { shareHistoryConfig } from '@/lib/analytics/charts/linkedin/shareHistory';
import { postClicksHistoryConfig } from '@/lib/analytics/charts/linkedin/postClicksHistory';
import { videoViewsHistoryConfig } from '@/lib/analytics/charts/linkedin/videoViewsHistory';

//widget
import { mostEngagingPostsConfig } from '@/lib/analytics/widget/linkedin/mostEngagingPostConfig';

export const EngagementLinkedin = [
    totalEngagementConfig,
    { ...avgEngagementRatePostConfig, size: SIZE_33 },
    avgEngagementOnImpressionConfig,
    //line 2
    mostEngagingPostsConfig,
    //line 3
    totalReactionsConfig,
    avgReactionsConfig,
    totalCommentsReceivedConfig,
    avgCommentsConfig,
    //line 4
    reactionsHistoryConfig,
    commentsHistoryConfig,
    //line 5
    bestTimeToPostConfig,
    //line 6
    avgEngagementsPostTypeConfig,
    avgEngagementRateHistoryConfig,
    //line 7
    totalSharesConfig,
    avgSharesConfig,
    totalClicksConfig,
    avgClicksPerPostConfig,
    //line 8
    shareHistoryConfig,
    postClicksHistoryConfig,
    //line 9
    { ...totalViewsConfig, size: SIZE_50 },
    { ...avgVideoViewsConfig, size: SIZE_50 },
    //line 10
    { ...videoViewsHistoryConfig, size: SIZE_FULL }
];

export const requestLinkedinParams = [
    // LinkedinMedia
    [
        'engagement',
        'average_engagement_rate_per_post',
        'average_engagement_on_impressions',
        'reactions',
        'average_reactions_per_post',
        'comments',
        'average_comments_per_post',
        'reactions_history',
        'comments_history',
        'best_time_to_post'
    ],
    [
        'average_engagement_per_post_type',
        'average_engagement_rate_history',
        'shares',
        'average_shares_per_post',
        'clicks',
        'average_clicks_per_post',
        'share_history',
        'clicks_history',
        'video_views',
        'average_views_per_video',
        'video_views_history'
    ]
];
